export const StoreStatus = {
  idle: 'idle',
  loading: 'loading',
  succeeded: 'succeeded',
  failed: 'failed',
} as const;

export type StoreStatusType = typeof StoreStatus[keyof typeof StoreStatus];